<template>
  <div class="f-contest"  v-show="arePostsPresent">
    <h2 @click="loadContest" class="title-container clickable">Contest<br/>"Alpine Food Heritage Stories"</h2>
    <b-row align-h="center" class="justify-content-md-center section"
           v-if="activeLanguage.winnersList && activeLanguage.winnersList.length > 0">
      <b-col>
        <div class="icon-wrapper">
          <div class="icon-container" v-on:click="loadWinners">
            <div class="contest-icon icon"></div>
          </div>
        </div>
        <p class="counterStyle">{{activeLanguage.winners}}</p>
      </b-col>
      <winners-modal ref="winnersModal"></winners-modal>
    </b-row>
    <b-row align-h="center" class="justify-content-md-center section">
      <b-col>
        <template v-if="new Date() >= new Date('4/23/2019 13:00:00')">
          <div v-if="new Date() >= new Date('6/16/2019 23:55:00')">
            <p class="loading-subtitle">{{activeLanguage.contestClosing}}</p>
          </div>
          <div class="post-container">
            <div :class="getContainerClass" :fit-width="true" item-selector=".item" transition-duration="0.3s"
                 v-masonry>
              <div :class="[{'card-mobile': $store.getters.isMobileValue}]" :key="index" class="item"
                   v-for="(post, index) in posts"
                   v-masonry-tile>
                <social-card :post-content="post"/>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <div>
            <p class="loading-subtitle">{{activeLanguage.contestOpening}}</p>
            <div class="contest-photo"></div>
          </div>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ContestPage from '../contestPageComponents/ContestPage'
  import SocialCard from '../../utilComponents/SocialCard'
  import WinnersModal from '../contestPageComponents/WinnersModal'

export default {
    name: 'Contest',
    components: {WinnersModal, SocialCard},
    data () {
      return {
        posts: []
      }
    },
    computed: {
      activeLanguage () {
        let currLang = this.$translations[this.$store.getters.currentLanguageValue]
        if (currLang.regulationsItems) {
          return this.$translations[this.$store.getters.currentLanguageValue]
        } else {
          return this.$translations['Italian']
        }
      },
      getContainerClass () {
        return this.isSmallWindow ? 'post-container-mobile' : 'post-container'
      },
      arePostsPresent () {
        return this.posts.length > 0
      }
    },
    methods: {
      loadContest () {
        this.$store.commit('setCurrentView', ContestPage)
        this.$router.push('/contest')
      },
      loadWinners () {
        this.$refs.winnersModal.showModal()
      },
      fetchMostRecentPosts () {
        let self = this
        this.$http.get(this.$PATH_NAME + 'contest/getHighlights/').then((response) => {
          self.posts = response.body
        })
      },
      handleOutDatedPost (userScreenName) {
        this.areInformationOutdated = true
        if (!this.profilesToUpdate) {
          this.profilesToUpdate = []
        }
        if (!this.profilesToUpdate.includes(userScreenName)) {
          this.profilesToUpdate.push(userScreenName)
          console.log('Ask to update picture of ' + userScreenName)
        }
      },
      updateOutDatedPost (userScreenName) {
        let self = this
        this.$http.get(this.$PATH_NAME + '/social/updateProfileInformation/profile=' + userScreenName).then((response) => {
          self.posts.forEach(post => {
            if (post.user.screenName === userScreenName) {
              post.user.profileImageUrl = response.body
            }
          })
        }
        ).catch(function (err) {
          this.handleError(err)
        })
      },
      checkWindowSize () {
        if ((!this.isSmallWindow) && window.innerWidth < 1051) {
          this.isSmallWindow = true
        } else if (this.isSmallWindow && window.innerWidth > 1051) {
          this.isSmallWindow = false
        }
      }
    },
    mounted () {
      this.fetchMostRecentPosts()
      this.checkWindowSize()
      window.addEventListener('resize', () => this.checkWindowSize())
    }
  }
</script>

<style scoped>

  .f-contest {
    /*background-color: whitesmoke;*/
    border-radius: 8px;
    height: 100%;
    padding: 3% 3% 3%;
  }

  .embed-frame {
    /*pointer-events: none;*/
  }

  .contest-icon {
    width: 1.25em;
    background-image: url("data:image/svg+xml;base64, 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 ");
  }

  .icon {
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 15% auto 0;
    width: 60px;
    height: 60px;
  }

  .icon-container {
    border: 1px solid grey;
    border-radius: 50%;
    margin: 0 auto 3%;
    width: 100px;
    height: 100px;
  }

  .icon-wrapper:hover {
    border: 5px solid #c41c21;
    transition: 500ms;
  }

  .icon-wrapper:hover > .icon-container > .icon { /*border: 5px solid #c41c21;*/ /*transition: 500ms;*/
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  /*.icon:hover, .icon:focus, .icon:active {*/
  /*-webkit-transform: scale(1.1);*/
  /*transform: scale(1.1);*/
  /*}*/

  .icon-wrapper {
    margin: 0 auto;
    border: 5px solid #f4f4f4;
    border-radius: 50%;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    width: 102px;
    height: 102px;
  }

  .loading-subtitle {
    font-size: 3vh;
    font-weight: bold;
    color: #888;
  }

  .post-container {
    margin-bottom: 2%;
  }

  .post-container-mobile {
    width: 100% !important;
  }

  .card-mobile > a > div {
    max-width: 500px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/Contest.vue